import $ from 'jquery';

export function initSectionSelection() {

    $(".sector-selection li:eq(0) a").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var h = 50;
        $(".sector-selection").toggleClass("open").css("height", $(".sector-selection").hasClass("open") ? $(".sector-selection li").length * h : h);
    });

    $(window).click(function () {
        if ($(".sector-selection").hasClass("open")) {
            $(".sector-selection").toggleClass("open").css("height", 50);
        }
    });

}
